module.exports = __webpack_public_path__ + "img/file2.521b0d90.png";